import React, { useState, useEffect, Fragment } from "react"
import { observer } from "mobx-react-lite"
import styled from "styled-components"

import store from "../../../../../store"
import { Styles } from "../../../../../config"
import { getNestedData } from "../../../../../util/accessors"


const VesselVariantConfig = {
	filter: `
    top: 30px;
  `,
	default: ``,
	public: ``,
	chatbot: ``
}

const Vessel = styled.div`
	display: ${(props) => (props.open ? "flex" : "none")};
	align-items: flex-start;
	flex-direction: column;
	width: fit-content;
	min-width: 300px;
	font-size: 16px;
	position: fixed;
	top: ${(props) => {
		return `${props.vesselPosition.top + 40}px`
	}};
	left: ${(props) => `${props.vesselPosition.left}px`};
	right: ${(props) => `${props.vesselPosition.right}px`};
	background: ${Styles.Color.white};
	border-radius: 5px;
	z-index: 1001;
	box-shadow: 0 24px 38px 3px rgb(127 194 255 / 19%), 0 9px 46px 8px rgb(127 194 255 / 27%),
		0 11px 15px -7px rgb(127 194 255 / 2%);
	padding: 8px 0;
	max-height: ${(props) => `${props?.optionRows * 40}px`};
	overflow-y: auto;
	max-width: 700px;
	${(props) => (props.variant ? VesselVariantConfig[props.variant] : "")}
`

const OuterOption = styled.div`
	outline: none;
	display: flex;
	align-items: flex-start;
	flex-direction: column;
	padding: 10px 0px;
	height: 20px;
	width: 100%;
	z-index: 1001;
	// border-bottom: 1px solid black;

	&:hover {
		background: rgba(0, 0, 0, 0.08);
		cursor: pointer;
	}
`

const InnerOption = styled.div`
	padding: 0px 20px;
	width: 85%;
	text-align: left;
	white-space: nowrap;
	color: ${Styles.Color.primary};
`
const ClickCatcher = styled.div`
	display: ${(props) => (props.open ? "flex" : "none")};
	position: fixed;
	width: 100vw;
	height: 100vh;
	z-index: 1000;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
`

const Menu = (props) => {
	const {
		options: optionsRaw,
		optionRows,
		onClose,
		onChange,
		name,
		optionsAccessor,
		optionsDisplayAccessor,
		optionsRefresher,
		value,
		input,
		isFocused,
		optionsMenuSelect,
		onBlur,
		setValues,
		values,
		optionsSelector,
		setFieldValue
	} = props

	const [optionsToDisplay, setOptionsToDisplay] = useState([])
	const [defaultOptions, setDefaultOptions] = useState([])
	const [vesselPosition, setVesselPosition] = useState({
		top: 0,
		left: 0,
		right: 0
	})
	const [mounted, setMounted] = useState(false)

	const refreshOptions = () => {
		let options = optionsRaw
		if (typeof options === "function") options = optionsRaw({ values })
		let newOptions = []
		if (options.size) newOptions = [...options.entries()].map(([key, value]) => value)
		else if (options.length) newOptions = options
		else newOptions = []
		setDefaultOptions(newOptions)
		setOptionsToDisplay(newOptions)
	}

	const getNewItems = async () => {
		const newProviders = await optionsRefresher({ value, defaultOptions })

		setOptionsToDisplay(newProviders)
	}

	useEffect(() => {
		if (input === "autocomplete" && optionsRefresher && isFocused) {
			getNewItems()
		}
	}, [value])

	useEffect(() => {
		if (input !== "autocomplete") refreshOptions()
	}, [optionsRaw?.size, optionsRaw?.length, values])

	useEffect(() => {
		if (!isFocused && input === "autocomplete" && mounted) {
			setTimeout(() => onBlur({ target: { name, value, input } }), 1)
		}
		setMounted(true)
	}, [isFocused])

	useEffect(() => {
		if (props.open && props.anchorEl) {
			const { top, left, right } = props.anchorEl?.getBoundingClientRect()

			const optionsLength = optionsToDisplay.length
			const menuHeight = optionsLength < 10 ? optionsLength * 40 : 470
			let topVal = window.innerHeight - top > menuHeight ? top : top - menuHeight

			setVesselPosition({ top: topVal, left, right })
		}
	}, [props.open, store.util.scrollY])

	return (
		<Fragment>
			<Vessel
				id={`select-menu-${name}`}
				open={true}
				variant={props.variant}
				optionRows={optionRows || 10}
				vesselPosition={vesselPosition}
			>
				{optionsToDisplay.map((option, index) => {
					return (
						<OuterOption
							key={index}
							id={`${index}-${name}-option`}
							className="option"
							tabIndex={-1}
							onMouseDown={(e) => {
								// e.preventDefault();
								onChange({ ...e, target: { ...e.target, name, value: option } }, name, option, index)
								optionsMenuSelect &&
									optionsMenuSelect({
										values: { ...values, [name]: option },
										setValues
									})
								optionsSelector && optionsSelector({ value: option, setFieldValue })
								onClose()
							}}
						>
							<InnerOption>
								{typeof option === "string"
									? option
									: getNestedData({
											object: option,
											path: optionsDisplayAccessor || optionsAccessor
									  })}
							</InnerOption>
						</OuterOption>
					)
				})}
			</Vessel>
			<ClickCatcher {...props} onClick={() => onClose()}></ClickCatcher>
		</Fragment>
	)
}

export default observer(Menu)
